export const BORDER_WIDTH = 1.5
export const SCATTERPLOT_BASELINE_SIZE = 4
export const SCATTERPLOT_COMPARISON_SIZE = 3
